import React from 'react';
import { LazyImage } from 'components/LazyImage';
import styled from 'styled-components';
import { colorsV2 } from 'style/colors-v2';
import { Typography } from 'components/DesignSystemV2/Typography';
import { imageFitStyle } from 'style/css-style';

const Wrapper = styled.div`
  max-width: 300px;
  width: 100%;
  overflow: hidden;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 24px;
`;

const ImageWrapper = styled.div`
  margin-bottom: 8px;
  img {
    max-width: 100%;
    height: 40px;
  }
`;

const NewsWrapper = styled.a`
  display: flex;
  align-items: start;
  gap: 12px;
  color: ${colorsV2.neutral120};
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: text-decoration-color 0.3s ease;

  &:hover {
    text-decoration-color: ${colorsV2.neutral180};
  }
`;

const ThumbnailWrapper = styled.div`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  position: relative;
  border-radius: 8px;
  border: 2px solid ${colorsV2.white100};
  overflow: hidden;
  box-shadow: 0px 8px 20px 0px var(--NeutralAlphaNA10),
    0px 3px 6px 0px var(--NeutralAlphaNA10),
    0px 0px 1px 0px var(--NeutralAlphaNA10);

  img {
    ${imageFitStyle('cover')}
  }
`;

const Description = styled(Typography)`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Name = styled(Typography)`
  text-align: center;
  padding: 4px 9px;
  border: 1px solid ${colorsV2.neutral20};
  border-radius: 8px;
`;

const LinearThinkingNewsSlideItem = ({
  logo = '',
  logoName = '',
  thumbnail = '',
  newsTitle = '',
  actionUrl = ''
}) => {
  return (
    <Wrapper className="keen-slider__slide">
      <ImageWrapper>
        <LazyImage handle={logo} alt={logoName} />
      </ImageWrapper>
      <NewsWrapper href={actionUrl} target="_blank" rel="noopener noreferrer">
        <ThumbnailWrapper>
          <LazyImage handle={thumbnail} alt={newsTitle} />
        </ThumbnailWrapper>
        <Description
          variant="regular/14-20"
          color={colorsV2.neutral180}
          type="span"
        >
          {newsTitle}
        </Description>
      </NewsWrapper>
      <Name variant="medium/14-20" color={colorsV2.neutral140} as="div">
        {logoName}
      </Name>
    </Wrapper>
  );
};

export default LinearThinkingNewsSlideItem;
